export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
};

const inView = (el) => {
  const r = el.getBoundingClientRect();
  return r.top >= 0 && r.bottom <= window.innerHeight;
};

export const focusWaitlist = () => {
  const input = document.getElementById("waitlist-email");
  scrollToId("join");
  if (!input) return;
  if (inView(input) && document.getElementById("join").getBoundingClientRect().top === 0) {
    input.focus({ preventScroll: true });
    return;
  }
  const cleanup = [];
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    cleanup.forEach((fn) => fn());
    input.focus({ preventScroll: true });
  };
  if ("onscrollend" in window) {
    window.addEventListener("scrollend", finish, { once: true });
    cleanup.push(() => window.removeEventListener("scrollend", finish));
  } else {
    const io = new IntersectionObserver(([e]) => e.isIntersecting && finish(), { threshold: 1 });
    io.observe(input);
    cleanup.push(() => io.disconnect());
  }
  const t = setTimeout(finish, 3000);
  cleanup.push(() => clearTimeout(t));
};
